import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Context } from "../../../Context";
import { ApartmentViewContext } from "../context/ApartmentViewContext";
import {
  infoModeName,
  arrangeModeName,
  insolationModeName,
  stylesModeName,
  hotSpotModeName,
  isometricModeName,
} from "../context/contextStrings";
import CompartmentsList from "./CompartmentsList";
import styles from "../../../styles/aprt.module.scss";

function CompartmentsBlock({ 
  apartmentViewMode, 
  apartmentData, 
  // compartmentsDictionary 
}) {
  const {
    apartmentViewInteractions,
    setApartmentViewInteractions,
    userSelectedArrangements,
    urlComboParam,
    setUrlComboParam, //temporary solution, TODO: refactor to use URL Params from react-router-dom
  } = useContext(ApartmentViewContext);
  const { compartmentsDictionary } = useContext(Context);
  const { t } = useTranslation();
  const { mode } = apartmentViewMode;
  const {
    hoveredCompartmentInd,
    selectedCompartmentInd,
    isCompartmentPathHovered,
  } = apartmentViewInteractions;

  //TODO: decide if we want to force two column layout?
  //TODO: set value here or in context? dynamic based on number of compartments?
  //TODO: BUG FIX in indoorCompartments if splitting to second column
  const maximumNumberOfCompartmentListRows = apartmentData?.compartments.length;
  const getOutdoorCompartmentNameIds = () =>
    // compartmentsDictionary?.compartments
    compartmentsDictionary
      .filter((room) => room.group === "OutdoorSpace")
      .map((room) => room.id);

  const outdoorCompartmentIds = getOutdoorCompartmentNameIds();
  const compartments = apartmentData?.compartments || [];

  const unsortedIndoorCompartments = compartments.filter(
    (room) => !outdoorCompartmentIds.includes(room.name)
  );
  const indoorCompartments = unsortedIndoorCompartments.sort((a, b) => {
    return parseInt(a.number, 10) - parseInt(b.number, 10);
  });

  const outdoorCompartments = compartments.filter((room) =>
    outdoorCompartmentIds.includes(room.name)
  );
  const forcedSecondColumn =
    indoorCompartments.length < maximumNumberOfCompartmentListRows;

    //now exporting from ./utils/compartmentHelpers.js
  const getNumbersOfArrangementVersions = (apartmentData) => {
    const sortedCompartments = apartmentData.compartments.sort((a, b) => {
      return parseInt(a.number) - parseInt(b.number);
    });
    const arrangementVersions = sortedCompartments.map(
      (compartment) => compartment.versions
    );
    return arrangementVersions;
  };

  const arrangementVersions = getNumbersOfArrangementVersions(apartmentData);

  const numberOfPossibleArrangements = arrangementVersions.reduce(
    (acc, num) => acc * num,
    1
  );

  // const currentCombinationNumber = currentArrangements.reduce(
  //   (acc, num) => acc * num,
  //   1
  // );
  //TODO: move formatArea to utils:
  //now exporting from ../../../utils/formattingUtils.js
  const formatArea = (num) => {
    if (num) {
      const roundedNumber = num.toFixed(2);
      const localeString = (number) =>
        number.toLocaleString("pl-PL", {
          minimumFractionDigits: 2,
        });

      return localeString(+roundedNumber);
    }
    return "";
  };

  //TODO: move to utils?:
  const getClassName = (baseClass, selectedClass, highlightedClass, ind) => {
    // if (apartmentViewMode.mode != arrangeModeName) {
    if (hoveredCompartmentInd === ind) return highlightedClass;
    if (selectedCompartmentInd === ind) return selectedClass;
    // }
    return baseClass;
  };

	const getListRowClassName = (ind) => {
		return getClassName(
			// styles.list__row,
      styles.list__row_compartments,
			styles.list__row_selected,
			styles.list__row_highlight,
			ind
		);
	};

  const getListDtClassName = (ind) => {
    return getClassName(
      styles.compartmentsList__dt,
      styles.compartmentsList__dt_selected,
      styles.compartmentsList__dt_highlight,
      ind
    );
  };

  const getListDdClassName = (ind) => {
    return getClassName(
      styles.compartmentsList__dd,
      styles.compartmentsList__dd_selected,
      styles.compartmentsList__dd_highlight,
      ind
    );
  };

  const handleRoomHover = (ind, isOnPath) => {
    //TODO: move to utils, isOnPath is here for this same function is also called on path hover
    ind === null
      ? setApartmentViewInteractions(
          ({ isCompartmentPathHovered, hoveredCompartmentInd, ...rest }) => ({
            isCompartmentPathHovered: false,
            hoveredCompartmentInd: null,
            ...rest,
          })
        )
      : setApartmentViewInteractions(
          ({ isCompartmentPathHovered, hoveredCompartmentInd, ...rest }) => ({
            isCompartmentPathHovered: isOnPath,
            hoveredCompartmentInd: ind,
            ...rest,
          })
        );
  };

  const handleRoomClickInArrangeMode = (ind) => {
    //TODO: move to utils - the same function is in PlanRendererArrangeMode
    const clickedCompartmentIndex = ind - 1;
    const availableNumberOfVersions =
      arrangementVersions[clickedCompartmentIndex];

    //TODO: temporary, refactor to use URL Params from react-router-dom
    const currentArrangementSelection = userSelectedArrangements;

    const updateSelectionArray = (prev) => {
      const newArr = [...prev];
      newArr[clickedCompartmentIndex] =
        (newArr[clickedCompartmentIndex] + 1) % availableNumberOfVersions;

      return newArr;
    };

    const newArrangementSelection = updateSelectionArray(
      currentArrangementSelection
    );

    const encodeCombination = (
      //TEMPORARY FUNC DECLARATION - TODO: import from utils
      arrangementsArray,
      variantsPerElement
    ) => {
      let encodedValue = 0;
      for (let i = 0; i < arrangementsArray.length; i++) {
        let product = 1;
        for (let j = i - 1; j >= 0; j--) {
          product *= variantsPerElement[j];
        }
        encodedValue += arrangementsArray[i] * product;
      }
      return encodedValue;
    };

    const encodedCombination = encodeCombination(
      newArrangementSelection,
      arrangementVersions
    );

    setUrlComboParam(encodedCombination);
  };

  const handleRoomClick = (ind) => {
    //TODO: move to utils
    selectedCompartmentInd === ind
      ? // !ind
        setApartmentViewInteractions(({ selectedCompartmentInd, ...rest }) => ({
          selectedCompartmentInd: null,
          ...rest,
        }))
      : setApartmentViewInteractions(({ selectedCompartmentInd, ...rest }) => ({
          selectedCompartmentInd: ind,
          ...rest,
        }));
  };
  //TODO: move to utils:
    //now exporting from ../../../utils/formattingUtils.js
  const convertNumberToHHMM = (num) => {
    const milliseconds = num * 60 * 60 * 1000;
    const timeString = new Date(milliseconds).toISOString().slice(11, 16);
    let [hours, minutes] = timeString.split(":");
    hours = parseInt(hours, 10);

    return `${hours}:${minutes}`;
  };
  //TODO: move to utils:
    //now exporting from ../../../utils/formattingUtils.js
  const convertArrayToHoursRange = (arr, num) => {
    if (!arr || arr.length === 0) {
      if (num === null) return t("not_calculated");
      if (num === 0) return t("no_window");
      return t("lack_of_sun");
    }
    const ranges = arr.map((range) => {
      const [start, end] = range;
      return `${convertNumberToHHMM(start)} - ${convertNumberToHHMM(end)}`;
    });
    return ranges.join(", ");
  };

  const renderIndoorCompartmentsList = () => {
    //TODO: BUG FIX: when indoorCompartment is long enough to force second column, forced indoor compartments appear on the bottom and second columns seams flipped
    //TODO: important!! refactor this to remove redundant code

    return indoorCompartments.map((compartment) => {
      const compartmentName = compartmentsDictionary?.find(
        (comp) => comp.id === compartment.name_cad
      );
      // const compartmentName = compartmentsDictionary?.compartments.find(
      //   (comp) => comp.id === compartment.name_cad
      // );
      
      const compartmentNameOriginal = compartmentName
        ? compartmentName.name_pl
        : compartment.name_original;

      const compartmentArrangements =
        arrangementVersions[compartment.number - 1];

      //TODO: add cases for different modes
      //info mode case:

      if (
        apartmentViewMode.mode === infoModeName ||
        apartmentViewMode.mode === stylesModeName
      )
        return (
          <div
            key={`indoorCompartment_${compartment.number}`}
            onClick={() => handleRoomClick(compartment.number)}
            onMouseEnter={() => handleRoomHover(compartment.number, false)}
            onMouseLeave={() => handleRoomHover(null)}
            className={getListRowClassName(compartment.number)}
          >
            <dt className={getListDtClassName(compartment.number)}>
              {`${compartmentNameOriginal}`}
              {`:`}
            </dt>
            <dd className={getListDdClassName(compartment.number)}>
              {`${formatArea(compartment.area_original)} m`}
              {<sup>2</sup>}
            </dd>
          </div>
        );
      //insolation mode case:
      if (apartmentViewMode.mode === insolationModeName)
        return (
          <div
            key={`indoorCompartment_${compartment.number}`}
            onClick={() => handleRoomClick(compartment.number)}
            onMouseEnter={() => handleRoomHover(compartment.number, false)}
            onMouseLeave={() => handleRoomHover(null)}
            className={getListRowClassName(compartment.number)}
          >
            <dt className={getListDtClassName(compartment.number)}>
              {`${compartmentNameOriginal}`}
              {`:`}
            </dt>
            <dd className={getListDdClassName(compartment.number)}>
              {outdoorCompartmentIds.includes(compartment.name) 
              ? t('not_calculated')
              : convertArrayToHoursRange(
                compartment.sun_light_ranges,
                compartment.window_area
              )}
            </dd>
          </div>
        );
      //arrange mode case:
      if (apartmentViewMode.mode === arrangeModeName)
        return (
          <div
            key={`indoorCompartment_${compartment.number}`}
            onClick={() => handleRoomClickInArrangeMode(compartment.number)}
            onMouseEnter={() => handleRoomHover(compartment.number, false)}
            onMouseLeave={() => handleRoomHover(null)}
            className={getListRowClassName(compartment.number)}
            style={compartmentArrangements === 1 ? { cursor: "auto" } : {}}
          >
            <dt className={getListDtClassName(compartment.number)}>
              {`${compartmentNameOriginal}`}
              {`:`}
            </dt>
            <dd
              className={getListDdClassName(compartment.number)}
              style={compartmentArrangements === 1 ? { color: "#ccc" } : {}}
            >
              {compartmentArrangements != 1 ? (
                <>
                {/* <button>{`<`}</button> */}
                  <span>
                    {userSelectedArrangements[compartment.number - 1] + 1}
                  </span>
                  <span className={styles.compartmentsList__versions}>{` /${compartmentArrangements}`}</span>
                  {/* <button>{`<`}</button> */}
                </>
              ) : (
                `1`
              )}
            </dd>
          </div>
        );
      //hotSpot mode case:
      if (apartmentViewMode.mode === hotSpotModeName) {
        const currentTier = apartmentData.compartments[0].ref_tier; //TODO: this should come form context; for now apartments are one level so current tier is first compartment tier
        const apartmentTiersData = apartmentData.tiers.find(
          (tier) => tier.ref_tier === currentTier
        );
        const apartmentCameras = apartmentTiersData.cameras;
        const apartmentHotSpots = apartmentCameras.filter(
          (camera) => camera.name !== "top_3D" && camera.name !== "axonometric"
        );
        const compartmentsWithHotSpots = apartmentHotSpots.map(
          (hotSpot) => hotSpot.name.split("_")[1]
        );

          const minNumberByName = {};
          indoorCompartments.forEach((c) => {
            if (
              compartmentsWithHotSpots.includes(c.name_cad) &&
              (minNumberByName[c.name_cad] === undefined ||
                c.number < minNumberByName[c.name_cad])
            ) {
              minNumberByName[c.name_cad] = c.number;
            }
          });

        return (
          <div
            key={`indoorCompartment_${compartment.number}`}
            name={compartment.name_cad}
            style={{
              display:
                compartmentsWithHotSpots.includes(compartment.name_cad) &&
                compartment.number === minNumberByName[compartment.name_cad]
                  ? ""
                : "none",
            }}
            onClick={() => handleRoomClick(compartment.number)}
            onMouseEnter={() => handleRoomHover(compartment.number, false)}
            onMouseLeave={() => handleRoomHover(null)}
            className={getListRowClassName(compartment.number)}
          >
            <dt className={getListDtClassName(compartment.number)}>
              {`${compartmentNameOriginal}`}
            </dt>
            <dd className={getListDdClassName(compartment.number)}></dd>
          </div>
        );
      }
      //isometricView mode case:
      if (apartmentViewMode.mode === isometricModeName) {
        return (
          <div
            key={`indoorCompartment_${compartment.number}`}
            onClick={() => handleRoomClick(compartment.number)}
            onMouseEnter={() => handleRoomHover(compartment.number, false)}
            onMouseLeave={() => handleRoomHover(null)}
            className={getListRowClassName(compartment.number)}
          >
            <dt className={getListDtClassName(compartment.number)}>
              {`${compartmentNameOriginal}`}
              {`:`}
            </dt>
            <dd className={getListDdClassName(compartment.number)}>
              {`${formatArea(compartment.area_original)} m`}
              {<sup>2</sup>}
            </dd>
          </div>
        );
      }

      return (
        <div
          key={`indoorCompartment_${compartment.number}`}
          onClick={() => handleRoomClick(compartment.number)}
          onMouseEnter={() => handleRoomHover(compartment.number, false)}
          onMouseLeave={() => handleRoomHover(null)}
          className={getListRowClassName(compartment.number)}
        >
          <dt className={getListDtClassName(compartment.number)}>
            {`${compartmentNameOriginal}`}
            {`:`}
          </dt>
          <dd className={getListDdClassName(compartment.number)}>
            {`${formatArea(compartment.area_original)} m`}
            {<sup>2</sup>}
          </dd>
        </div>
      );
    });
  };

  const renderOutdoorCompartmentsList = () => {
    //TODO: important!! refactor this to remove redundant code
    //info mode case:
    return outdoorCompartments.map((compartment) => {
      const compartmentName = compartmentsDictionary?.compartments.find(
        (comp) => comp.id === compartment.name
      );
      const compartmentNameOriginal = compartmentName
        ? compartmentName.name_pl
        : compartment.name;

      const compartmentArrangements =
        arrangementVersions[compartment.number - 1];

      if (
        apartmentViewMode.mode === infoModeName ||
        apartmentViewMode.mode === stylesModeName
      )
        return (
          <div
            key={`outdoorCompartment_${compartment.number}`}
            onClick={() => handleRoomClick(compartment.number)}
            onMouseEnter={() => handleRoomHover(compartment.number, false)}
            onMouseLeave={() => handleRoomHover(null)}
            className={getListRowClassName(compartment.number)}
          >
            <dt className={getListDtClassName(compartment.number)}>
              {`${compartmentNameOriginal}`}
              {`:`}
            </dt>
            <dd className={getListDdClassName(compartment.number)}>
              {`${formatArea(compartment.area_original)} m`}
              {<sup>2</sup>}
            </dd>
          </div>
        );

      if (apartmentViewMode.mode === insolationModeName)
        return (
          <div
            key={`outdoorCompartment_${compartment.number}`}
            onClick={() => handleRoomClick(compartment.number)}
            onMouseEnter={() => handleRoomHover(compartment.number, false)}
            onMouseLeave={() => handleRoomHover(null)}
            className={getListRowClassName(compartment.number)}
          >
            <dt className={getListDtClassName(compartment.number)}>
              {`${compartmentNameOriginal}`}
              {`:`}
            </dt>
            <dd className={getListDdClassName(compartment.number)}>
              {convertArrayToHoursRange(
                compartment.sun_light_ranges,
                compartment.window_area
              )}
            </dd>
          </div>
        );
      //arrange mode case:
      if (apartmentViewMode.mode === arrangeModeName)
        return (
          <div
            key={`outdoorCompartment_${compartment.number}`}
            onClick={() => handleRoomClickInArrangeMode(compartment.number)}
            onMouseEnter={() => handleRoomHover(compartment.number, false)}
            onMouseLeave={() => handleRoomHover(null)}
            className={getListRowClassName(compartment.number)}
            style={compartmentArrangements === 1 ? { cursor: "auto" } : {}}
          >
            <dt className={getListDtClassName(compartment.number)}>
              {`${compartmentNameOriginal}`}
              {`:`}
            </dt>
            <dd
              className={getListDdClassName(compartment.number)}
              style={compartmentArrangements === 1 ? { color: "#ccc" } : {}}
            >
              {compartmentArrangements != 1
                ? `${
                    userSelectedArrangements[compartment.number - 1] + 1
                  } / ${compartmentArrangements}`
                : `1`}
            </dd>
          </div>
        );
      //hotSpot mode case - show only compartments with hotSpots?:
      if (apartmentViewMode.mode === hotSpotModeName)
        return (
          <>
            {/* <div
              key={`outdoorCompartment_${compartment.number}`}
              onClick={() => handleRoomClickInArrangeMode(compartment.number)}
              onMouseEnter={() => handleRoomHover(compartment.number, false)}
              onMouseLeave={() => handleRoomHover(null)}
              className={getListRowClassName(compartment.number)}
            >
              <dt className={getListDtClassName(compartment.number)}>
                {`${compartmentNameOriginal}`}
                {`:`}
              </dt>
              <dd className={getListDdClassName(compartment.number)}>
                {`${
                  userSelectedArrangements[compartment.number - 1] + 1
                } / ${compartmentArrangements}`}
              </dd>
            </div> */}
          </>
        );
      return (
        <div
          key={`outdoorCompartment_${compartment.number}`}
          onClick={() => handleRoomClick(compartment.number)}
          onMouseEnter={() => handleRoomHover(compartment.number, false)}
          onMouseLeave={() => handleRoomHover(null)}
          className={getListRowClassName(compartment.number)}
        >
          <dt className={getListDtClassName(compartment.number)}>
            {`${compartmentNameOriginal}`}
            {`:`}
          </dt>
          <dd className={getListDdClassName(compartment.number)}>
            {`${formatArea(compartment.area_original)} m`}
            {<sup>2</sup>}
          </dd>
        </div>
      );
    });
  };

    //now exporting from ../../../utils/formattingUtils.js
  const formatNumber = (number) => {
    if (isNaN(number)) {
      return number;
    }

    return number.toLocaleString("pl-PL", {
      style: "decimal",
    });
  };

  return (
    <div className={styles.compartmentsList__block}>
      <h3 className={styles.heading__compartments}>
        {mode === infoModeName && t("compartments_areas")}
        {mode === stylesModeName && t("compartments_areas")}
        {/*TODO: when we add multiple 3d styles add a heading ie. "Pomieszczenia - wykończenia"*/}
        {mode === arrangeModeName && t("compartments_arrangements")}
        {mode === insolationModeName && t("compartments_insolation")}
        {mode === hotSpotModeName && t("compartments_hot_spots")}
        {mode === isometricModeName && t("compartments_list")}
        {!mode && t("compartments_list")}
      </h3>
      <CompartmentsList
        IndoorCompartmentsList={renderIndoorCompartmentsList()}
        OutdoorCompartmentsList={renderOutdoorCompartmentsList()}
        forcedSecondColumn={forcedSecondColumn} //TODO: decide if we want to force two column layout
        maximumRowsNumber={maximumNumberOfCompartmentListRows}
      />
      {mode === arrangeModeName &&
        (numberOfPossibleArrangements > 1 ? (
          <p>
            Wybrano wariant <b>{formatNumber(urlComboParam + 1)}</b> spośród{" "}
            {formatNumber(numberOfPossibleArrangements)} możliwych.
          </p>
        ) : (
          <p>Dla tego apartamentu nie przygotowano wariantowania aranżacji</p>
        ))}
    </div>
  );
}

export default CompartmentsBlock;